import { BRAND } from '../generated/brand';

export const showMenuIcons =
  BRAND.web?.showMenuIcons ?? true;
